import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEN from '../locales/en.json';
import translationES from '../locales/es.json';
import translationCA from '../locales/ca.json';
import translationFR from '../locales/fr.json';
import translationIT from '../locales/it.json';
import translationDE from '../locales/de.json';
import translationPT from '../locales/pt.json';

const resources = {
  en: {
    translation: translationEN,
    label: 'English',
  },
  es: {
    translation: translationES,
    label: 'Español',
  },
  ca: {
    translation: translationCA,
    label: 'Català',
  },
  fr: {
    translation: translationFR,
    label: 'Français',
  },
  it: {
    translation: translationIT,
    label: 'Italiano',
  },
  de: {
    translation: translationDE,
    label: 'Deutsch',
  },
  pt: {
    translation: translationPT,
    label: 'Português',
  },
};

const options = {
  order: ['sessionStorage', 'navigator'],
  // lng: 'es',
  // lookupQuerystring: 'lng',
  // lookupCookie: 'i18next',
  // lookupLocalStorage: 'i18nextLng',
  lookupSessionStorage: 'i18nextLng',

  // cache user language
  // caches: ['localStorage'],
  // excludeCacheFor: ['cimode'],
  // cookieMinutes: 10,
  // cookieDomain: 'myDomain'
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: options,
    fallbackLng: 'en',
    resources,

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export const languages = Object
  .entries(resources)
  .map(item => ({ key: item[0], label: item[1].label}))
  .sort((a, b) => a.key.localeCompare(b.key));
